export const SEGMENTED_VALUE = "SEGMENTED";
export const MENTION_VALUE = "MENTION";
